export default "__VITE_ASSET__DSHj07yM__"